export default{
    paddingPage: 15,
    padding: 10,
    margin: 10,
}


// WEBPACK FOOTER //
// ./src/styles/metrics.js